<!-- <div class="mb-2 small">Pick Slip</div> -->
<form>
  <div class="bg-white rounded-10 p-3">
    <div class="small text-center mb-3 mx-xl-4">
      Simulated gambling only. No real money is wagered, won, or lost
    </div>
    <div class="row mb-4">
      <div class="col small align-self-center">Straight Picks</div>
      <div class="col-auto d-flex align-items-center">
        <strong>$ &nbsp;</strong>
        <input
          type="number"
          class="form-control w-80px"
          [disabled]="parlay"
          [(ngModel)]="straight"
          (input)="setPickAmount(straight)"
          name="straight"
        />
      </div>
    </div>
    <table class="pick-slip-table">
      <tr>
        <td>Your selection</td>
        <td>Odds</td>
        <td class="text-end">Stake</td>
      </tr>
      <tr *ngFor="let item of _sport.pickslip | async; index as i">
        <td colspan="3">
          <div
            class="pick-slip-teams-name rounded-10 small p-2 fw-normal card-shadow-sm bg-light"
            [class.red-border]="errorid.includes(item.marketid)"
          >
            <div class="fw-bold">
              <span (click)="removeItem(i)">
              <i
                class="fa fa-times text-danger c-pointer"
              ></i>
              </span>
              {{ item.teams }}
            </div>
            <div class="row mt-2">
              <div class="pt-13 col">
                {{ item.team_bet }}
              </div>
              <div class="text-primary pt-13 col-auto fw-bold">
                {{ item.line }}
              </div>
              <div class="text-end col-auto">
                <div class="d-flex fw-bold">
                  <div class="align-self-center me-1 ms-auto">$</div>
                  <input
                    type="text"
                    class="form-control w-80px fw-bold text-f16 text-end"
                    [value]="item.bet_amount"
                    [disabled]="parlay"
                    name="amount"
                    #amount
                    (input)="
                      item.bet_amount = amount.value;
                      _sport.pickslip.next(_sport.pickslip.getValue())
                    "
                  />
                </div>
                <div *ngIf="item.bet_amount" class="pe-1 fw-bold">
                  {{
                    Math.round((item.odd - 1) * item.bet_amount)
                      | CustomCurrency
                  }}
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div class="bg-light p-3 rounded-10 mt-5">
      <!-- <div class="mb-2 small">Parlay Picks</div> -->
      <div
        class="pick-slip-teams-name bg-white rounded-10 py-2 card-shadow-sm mb-3"
      >
        <!-- <div class="row mx-0 mb-2">
          <div class="align-self-center fw-bold col">Parlay</div>
          <div class="col-auto">
            <label class="switch mt-1" for="checkbox_{{ unique }}">
              <input
                type="checkbox"
                id="checkbox_{{ unique }}"
                class="switch-checkbox"
                name="parlay"
                [(ngModel)]="parlay"
              />
              <div class="switch-slider round"></div>
            </label>
          </div>
        </div>
        <div class="row mx-0" [hidden]="!parlay">
          <div class="col py-1 small align-self-center">Parlay Amount:</div>
          <div class="col-auto py-1">
            <input
              type="number"
              name="parlayAmount"
              class="form-control w-80px text-end text-f16"
              [(ngModel)]="parlayAmount"
              (input)="calculateParlay()"
            />
          </div>
        </div> -->
        <div class="row mx-0">
          <div class="col py-1 small">Total stake:</div>
          <div class="col-auto py-1 fw-bold pe-3">
            <!-- {{ sum(_sport.pickslip | async) | CustomCurrency }} -->
            {{ total_stake || 0 | CustomCurrency }}
          </div>
        </div>
        <div class="row mx-0">
          <div class="col py-1 small">To Win:</div>
          <div class="col-auto py-1 fw-bold pe-3">
            <!-- {{ towin(_sport.pickslip | async) | CustomCurrency }} -->
            {{ to_win | CustomCurrency }}
          </div>
        </div>
      </div>
      <div
        class="pick-slip-teams-name bg-white rounded-10 py-2 card-shadow-sm mb-3"
        *ngIf="(_sport.pickslip | async)?.length"
      >
        <div class="row mx-0">
          <div class="align-self-center fw-bold col">Confirm Pick(s)</div>
          <div class="col-auto">
            <label class="switch mt-1" for="confirm_{{ unique }}">
              <input
                type="checkbox"
                id="confirm_{{ unique }}"
                name="confirm"
                [(ngModel)]="confirm"
                class="switch-checkbox"
              />
              <div class="switch-slider round"></div>
            </label>
          </div>
        </div>
      </div>
      <div class="row gx-3">
        <div class="col-auto" *ngIf="(_sport.pickslip | async)?.length">
          <button
            type="button"
            (click)="removeAll()"
            class="btn btn-light px-md-4 px-3"
          >
            Remove all
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-theme w-100 px-3"
            [disabled]="!confirm || _common.isLoading"
            (click)="placePicks()"
          >
            Place Picks
            <span *ngIf="_common.isLoading"><i class="fas fa-circle-notch fa-spin"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
